<div class="top-navi-container no-print">
  <img class="logo" src="/assets/images/theradeaLogo-400x119.png" alt="" (click)="navigateHome()"/>
  <ng-content></ng-content>
  @if (authService.isAuthenticated()) {
    <div class="align-right">
      <!-- <button class="top-navi align-right" (click)="releaseNotes()" mat-button>Neuigkeiten</button> -->
      <button class="top-navi align-right" (click)="editUser()" mat-button>{{ officeService.office()?.name }}</button>
      <button class="top-navi align-right" (click)="logout()" mat-button>Abmelden</button>
    </div>
  }
</div>
